// Motifs de route partagés entre `App.tsx` et les tests de routage. Le classement de la marketplace à
// froid face au splat `/sante?/*` ne se déduit pas d'une lecture : il dépend du score que React Router
// attribue à chaque motif, d'où `marketplaceRouting.spec.ts`.

/** Splat qui porte tout le tunnel d'inscription, Learning comme Santé. */
export const REGISTRATION_ROUTES_PATH = '/sante?/*'

/** Marketplace à froid. Le chemin porte l'habillage de marque ; le domaine de catalogue, lui, se dit
 * dans le paramètre `domain`, les deux ne coïncidant pas (Edumiam se rend en Learning). */
export const COLD_START_MARKETPLACE_PATHS = ['/formations', '/sante/formations'] as const

export const GROUP_DASHBOARD_PATH = '/groupe/:group_global_id'
export const GROUP_MARKETPLACE_PATH = '/groupe/:group_global_id/marketplace'
